import create from 'zustand';
import URL from 'url-parse';
import axios from 'axios';
import { getSignatureFromScan } from 'pbt-chip-client/kong';
import parseKeys from '../helpers/parseKeys';
import safeTag from '../helpers/safeTag';
import fromHexString from '../helpers/fromHexString';
import buf2hex from '../helpers/bufToHex';
import { IDevice, IKeys } from '../types';
import generateArweaveQuery from '../helpers/generateArweaveQuery';
import { ethers } from 'ethers';
import walletStore from './walletStore';
import { getChainData } from '../helpers/getChainData';
import publicKeyToAddress from '../helpers/publicKeyToAddress';
import { CONTRACT, baseURI, ERC721ABI } from '../lib/config';

// Note: one can create "test" records by modifying the Eth node and selecting a different chain in the wallet which signs.
const ARWEAVE_GRAPHQL =
  process.env.REACT_APP_ARWEAVE_NODE + '/graphql' ||
  'https://arweave.net/graphql';
const TAG_DOMAIN = process.env.REACT_APP_TAG_DOMAIN;

console.log(`tag domain is : ${TAG_DOMAIN}`);

// TODO: allow the user to select a chain id
const { chainId } = walletStore.getState();

const CHAIN_ID = process.env.REACT_APP_CHAIN_ID
  ? +process.env.REACT_APP_CHAIN_ID
  : 1;

const ETH_NODE = getChainData(CHAIN_ID).rpc_url;

type TDeviceStore = {
  keys: IKeys | null;
  device: IDevice | null;
  registered: boolean;
  getDeviceCompleted: boolean;
  creator: string | null;
  loading: boolean;
  init(): void;
  getDevice(): void;
  linkHalo(): Promise<boolean>;
  triggerScan(reqx: any): Promise<any>;
  setLoading(loading: boolean): void;
};

const deviceStore = create<TDeviceStore>((set) => ({
  keys: null,
  device: null,
  registered: false,
  getDeviceCompleted: false,
  creator: null,
  loading: false,

  init: () => {
    set({ keys: null });
    set({ device: null });
    set({ getDeviceCompleted: false });
    set({ device: null });
  },

  getDevice: async () => {
    console.log('Fetching the device');

    const { keys } = deviceStore.getState();

    // Return early if we don't have keys
    if (!keys) return;

    set({ loading: true });

    try {
      const provider: any = new ethers.providers.JsonRpcProvider(ETH_NODE);
      const block = await provider.getBlock();
      const address = publicKeyToAddress(keys.primaryPublicKeyRaw);
      // const signature = await getSignatureFromScan({
      //   chipPublicKey: keys.primaryPublicKeyRaw,
      //   address: '0xb98984d00D7DB241CE82e83A076e8b681F41d158',
      //   hash: block.hash,
      // });
      const contract = new ethers.Contract(CONTRACT, ERC721ABI, provider);
      const tokenData = await contract.functions._tokenDatas(address);
      const tokenId = await contract.functions.tokenIdMappedFor(address);
      // console.log('tokenData: ', tokenData, 'tokenId: ', tokenId);

      // alert(
      //   `blockNumber: ${JSON.stringify(
      //     block.number
      //   )}, signature: ${signature}, address: ${address}`
      // );

      set({ registered: tokenData[2] });
      const tokenMetadataResponse = await fetch(`${baseURI}${tokenId}`, {
        method: 'GET',
      });
      const tokenMetadataResult = await tokenMetadataResponse.json();
      console.log('token metadata: ', JSON.stringify(tokenMetadataResult));
      set({
        device: {
          device_id: tokenId,
          device_address: address,
          device_token_uri: `${baseURI}${tokenId}`,
          device_token_metadata: JSON.stringify(tokenMetadataResult),
        },
      });
      set({ loading: false, getDeviceCompleted: true });
    } catch (error) {
      console.error(error);
      set({ loading: false, getDeviceCompleted: true });
    }
  },
  triggerScan: async (reqx: any) => {
    try {
      var req: any = {
        publicKey: {
          allowCredentials: [
            {
              id: fromHexString(reqx),
              transports: ['nfc'],
              type: 'public-key',
            },
          ],
          challenge: new Uint8Array([
            113, 241, 176, 49, 249, 113, 39, 237, 135, 170, 177, 61, 15, 14,
            105, 236, 120, 140, 4, 41, 65, 225, 107, 63, 214, 129, 133, 223,
            169, 200, 21, 88,
          ]),
          rpId: TAG_DOMAIN,
          timeout: 60000,
          userVerification: 'discouraged',
        },
      };

      var xdd: any = await navigator.credentials.get(req);
      return xdd?.response.signature;
    } catch (err) {
      console.log('Error with scan', err);
    }
  },
  async linkHalo(): Promise<boolean> {
    const { triggerScan, getDevice } = deviceStore.getState();
    try {
      const sig = await triggerScan('02');
      if (typeof sig !== 'undefined') {
        const sss = buf2hex(sig);
        const keys = parseKeys(sss);
        if (keys) {
          set({ keys });
          getDevice();
          return true;
        }
        return false;
      }
      return false;
    } catch (error) {
      console.error('Error with link', error);
      return false;
    }
  },

  setLoading: (loading: boolean) => {
    set({ loading });
  },
}));

export default deviceStore;
